<template>
  <el-dialog
          :title="dialogTitle"
          :visible.sync="dialogVisible"
          width="700px"
          :before-close="handleClose"
          @open="handleDialogOpen"
  >
    <el-form
            :model="form"
            :rules="rules"
            ref="formRef"
            label-width="120px"
            size="mini"
    >
      <!-- 商户信息展示（只读） -->
      <el-form-item label="所属商家" v-if="selectedShopInfo">
        <div class="shop-info-display">
          <el-card shadow="never" style="margin-top: 8px;">
            <div class="selected-shop-content">
              <div class="selected-shop-header">
                <span class="selected-shop-name">{{ selectedShopInfo.name }}</span>
                <el-tag
                        :type="selectedShopInfo.status === 1 ? 'success' : 'danger'"
                        size="mini"
                >
                  {{ selectedShopInfo.status === 1 ? '正常营业' : '已禁用' }}
                </el-tag>
              </div>
              <div class="selected-shop-details">
                <div class="detail-item">
                  <i class="el-icon-location-outline"></i>
                  <span>区域: {{ getShopRegion(selectedShopInfo) }}</span>
                </div>
                <div class="detail-item">
                  <i class="el-icon-phone"></i>
                  <span>电话: {{ selectedShopInfo.mobile || selectedShopInfo.telephone || '暂无' }}</span>
                </div>
                <div v-if="selectedShopInfo.address" class="detail-item">
                  <i class="el-icon-office-building"></i>
                  <span>地址: {{ selectedShopInfo.address }}</span>
                </div>
                <div v-if="selectedShopInfo.cont_name" class="detail-item">
                  <i class="el-icon-user"></i>
                  <span>联系人: {{ selectedShopInfo.cont_name }}</span>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </el-form-item>

      <!-- 分润类型展示（只读） -->
      <el-form-item label="分润类型" v-if="selectedBalanceType">
        <div class="balance-type-display">
          <el-tag
                  :type="selectedBalanceType.type_id === 1 ? 'success' : 'warning'"
                  size="medium"
          >
            {{ getBalanceTypeName(selectedBalanceType.type_id) }}
          </el-tag>
          <div class="balance-type-desc" v-if="selectedBalanceType.remark">
            <i class="el-icon-info"></i>
            <span>{{ selectedBalanceType.remark }}</span>
          </div>
        </div>
      </el-form-item>

      <!-- 动态分润设置区域 -->
      <el-form-item label="分润设置" prop="balanceSettings">
        <div class="balance-settings-container">
          <div class="settings-header">
            <span class="header-title">业务编码 & 分润比例</span>
            <span class="header-tip">分润比例总和必须等于100%</span>
          </div>

          <div
                  v-for="(setting, index) in form.balanceSettings"
                  :key="index"
                  class="balance-setting-item"
          >
            <el-row :gutter="10" style="margin-bottom: 10px;">
              <el-col :span="10">
                <el-form-item
                        :prop="`balanceSettings.${index}.proxy_sn`"
                        :rules="proxySnRules"
                        style="margin-bottom: 0;"
                >
                  <el-input
                          v-model="setting.proxy_sn"
                          placeholder="请输入业务编码"
                          maxlength="50"
                          @blur="validateProxySn(setting)"
                  >
                    <template slot="prepend">编码 {{ index + 1 }}</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item
                        :prop="`balanceSettings.${index}.rate`"
                        :rules="rateRules"
                        style="margin-bottom: 0;"
                >
                  <el-input
                          v-model="setting.rate"
                          placeholder="分润比例"
                          type="number"
                          min="0"
                          max="100"
                          step="0.01"
                          @input="calculateTotalRate"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        size="mini"
                        @click="removeBalanceSetting(index)"
                        :disabled="form.balanceSettings.length === 1"
                        title="删除此项"
                ></el-button>
              </el-col>
            </el-row>
          </div>

          <!-- 总计和添加按钮 -->
          <div class="balance-total">
            <div class="total-info">
              <div class="total-rate">
                <span class="total-label">总计: </span>
                <span class="total-value">{{ totalRate.toFixed(2) }}%</span>
                <el-tag
                        :type="totalRate === 100 ? 'success' : 'danger'"
                        size="mini"
                        style="margin-left: 10px;"
                >
                  {{ totalRate === 100 ? '比例正确' : '比例错误' }}
                </el-tag>
              </div>
              <div v-if="totalRate !== 100" class="rate-tip">
                还差 {{ (100 - totalRate).toFixed(2) }}% 达到100%
              </div>
            </div>
            <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="mini"
                    @click="addBalanceSetting"
                    :disabled="form.balanceSettings.length >= 10"
            >
              添加分润设置
            </el-button>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="状态" prop="status">
        <el-switch
                v-model="form.status"
                :active-value="1"
                :inactive-value="0"
                active-text="启用"
                inactive-text="禁用"
        ></el-switch>
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input
                type="textarea"
                :rows="3"
                v-model="form.remark"
                placeholder="请输入备注信息"
                maxlength="200"
                show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="mini">取 消</el-button>
      <el-button
              type="primary"
              @click="submitForm"
              :loading="submitLoading"
              size="mini"
              :disabled="totalRate !== 100"
      >
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'eBalanceSettingDialog',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '新增分润设置'
      },
      editData: {
        type: Object,
        default: null
      },
      shopId: {
        type: [String, Number],
        default: null
      },
      balanceTypeId: {
        type: [String, Number],
        default: null
      }
    },
    data() {
      // 业务编码验证规则
      const validateProxySn = (rule, value, callback) => {
        if (!value || value.trim() === '') {
          callback(new Error('请输入业务编码'));
        } else if (value.length > 50) {
          callback(new Error('业务编码不能超过50个字符'));
        } else {
          callback();
        }
      };

      // 分润比例验证规则
      const validateRate = (rule, value, callback) => {
        if (value === '' || value === null || value === undefined) {
          callback(new Error('请输入分润比例'));
        } else {
          const numValue = parseFloat(value);
          if (isNaN(numValue)) {
            callback(new Error('请输入有效的数字'));
          } else if (numValue < 0) {
            callback(new Error('分润比例不能小于0'));
          } else if (numValue > 100) {
            callback(new Error('分润比例不能大于100'));
          } else {
            callback();
          }
        }
      };

      return {
        dialogVisible: this.visible,
        dialogTitle: this.title,
        submitLoading: false,

        // 商户信息
        selectedShopInfo: null,
        selectedBalanceType: null,

        // 表单数据
        form: {
          id: '',
          shop_id: '',
          balance_params_id: '',
          status: 1,
          remark: '',
          balanceSettings: [
            {
              proxy_sn: '',
              rate: '',
              id:'',
              balance_params_id:''
            }
          ]
        },

        // 验证规则
        rules: {
          balanceSettings: [
            {
              validator: (rule, value, callback) => {
                if (!value || value.length === 0) {
                  callback(new Error('至少需要一个分润设置'));
                  return;
                }

                // 检查业务编码是否重复
                const proxySns = value.map(item => item.proxy_sn).filter(sn => sn);
                const uniqueProxySns = [...new Set(proxySns)];
                if (proxySns.length !== uniqueProxySns.length) {
                  callback(new Error('业务编码不能重复'));
                  return;
                }

                callback();
              },
              trigger: 'change'
            }
          ]
        },

        // 单个字段的验证规则
        proxySnRules: [
          { required: true, message: '请输入业务编码', trigger: 'blur' },
          { validator: validateProxySn, trigger: 'blur' }
        ],
        rateRules: [
          { required: true, message: '请输入分润比例', trigger: 'blur' },
          { validator: validateRate, trigger: 'blur' }
        ],

        totalRate: 0
      };
    },
    watch: {
      visible(newVal) {
        this.dialogVisible = newVal;
      },
      title(newVal) {
        this.dialogTitle = newVal;
      },
      editData(newVal) {
        if (newVal) {
          this.initEditData(newVal);
        }
      },
      shopId: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.form.shop_id = newVal;
            this.fetchShopInfo(newVal);
          }
        }
      },
      balanceTypeId: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.form.balance_params_id = newVal;
            this.fetchBalanceTypeInfo(newVal);
          }
        }
      }
    },
    methods: {
      // 获取分润类型名称
      getBalanceTypeName(typeId) {
        const typeMap = {
          1: "加油站分润",
          2: "运企分润"
        };
        return typeMap[typeId] || '未知类型';
      },

      // 获取商户区域信息
      getShopRegion(shop) {
        const province = shop.province ? shop.province.region_name : '';
        const city = shop.city ? shop.city.region_name : '';
        const district = shop.district ? shop.district.region_name : '';
        return `${province}${city}${district}`;
      },

      // 获取分润类型信息
      async fetchBalanceTypeInfo(balanceTypeId) {
        if (!balanceTypeId) return;

        try {
          // 这里需要根据实际情况调用获取分润类型详情的接口
          // 假设有一个接口可以获取分润类型详情
          const params = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            id: balanceTypeId
          };

          // 如果没有专门接口，可以从商户的分润参数列表中查找


          // 如果上面没找到，尝试调用接口（这里需要根据实际情况调整）
          const res = await this.$axios.findShopBalanceParamsByShopList(params);
          if (res.code === 200 && res.data) {
            this.paramsList=res.data;
            if (this.paramsList && this.paramsList.length > 0) {
              const balanceType = this.paramsList.find(item => item.id == balanceTypeId);
              if (balanceType) {
                this.selectedBalanceType = {id:balanceType.id,type_id:balanceType.type_id,remark:''};
                return;
              }
            }
          }
        } catch (error) {
          console.error('获取分润类型信息失败:', error);
          // 如果获取失败，至少显示类型名称
          // this.selectedBalanceType = {
          //   id: balanceTypeId,
          //   type_id: this.form.balance_params_id,
          //   remark: ''
          // };
        }
      },

      // 初始化编辑数据
      async initEditData(row) {
        // 如果存在shop_id，获取商户详情
        if (row.shop_id) {
          await this.fetchShopInfo(row.shop_id);
        }
        // 如果存在分润类型ID，获取分润类型信息
        if (row.id) {
          await this.fetchBalanceTypeInfo(row.id);
        }

        // 转换数据格式
        this.form = {
          id: row.id,
          shop_id: row.shop_id,
          balance_params_id: row.id,
          status: row.status,
          remark: row.remark || '',
          balanceSettings: [
            {
              proxy_sn: '',
              rate: 0,
              id:'',
              balance_params_id: row.balance_params_id
            }
          ]
        };
        if(row.balanceset&&row.balanceset.length>0){
          this.form.balanceSettings=row.balanceset;
        }

        this.calculateTotalRate();
      },

      // 弹窗打开时的处理
      handleDialogOpen() {
        if (this.editData) {
          this.initEditData(this.editData);
        } else {
          this.resetForm();
        }

        // 如果父组件传递了shopId，加载商户信息
        if (this.shopId) {
          this.fetchShopInfo(this.shopId);
        }

        // 如果父组件传递了balanceTypeId，加载分润类型信息
        if (this.balanceTypeId) {
          this.fetchBalanceTypeInfo(this.balanceTypeId);
        }
      },

      // 重置表单
      resetForm() {
        this.form = {
          id: '',
          shop_id: this.shopId || '',
          balance_params_id: this.balanceTypeId || '',
          status: 1,
          remark: '',
          balanceSettings: [
            {
              proxy_sn: '',
              rate: '',
              id:'',
            }
          ]
        };
        this.selectedShopInfo = null;
        this.selectedBalanceType = null;
        this.totalRate = 0;

        this.$nextTick(() => {
          if (this.$refs.formRef) {
            this.$refs.formRef.clearValidate();
          }
        });
      },

      // 添加分润设置
      addBalanceSetting() {
        this.form.balanceSettings.push({
          proxy_sn: '',
          rate: '',
          id:'',
        });
      },
      // 删除分润设置
      removeBalanceSetting(index) {
        if (this.form.balanceSettings.length > 1) {
          this.form.balanceSettings.splice(index, 1);
          this.calculateTotalRate();
        }
      },
      // 计算总比例
      calculateTotalRate() {
        this.$nextTick(() => {
          let total = 0;
          this.form.balanceSettings.forEach(setting => {
            const rate = parseFloat(setting.rate) || 0;
            total += rate;
          });
          this.totalRate = total;
        });
      },

      // 验证业务编码唯一性
      validateProxySn(setting) {
        const sameProxySns = this.form.balanceSettings.filter(
                item => item.proxy_sn === setting.proxy_sn && item.proxy_sn !== ''
        );
        if (sameProxySns.length > 1) {
          this.$message.warning('业务编码不能重复');
          setting.proxy_sn = '';
        }
      },

      // 提交表单
      submitForm() {
        this.$refs.formRef.validate(async (valid) => {
          if (!valid) {
            this.$message.warning('请完善表单信息');
            return;
          }

          if (this.totalRate !== 100) {
            this.$message.warning('分润比例之和必须等于100%');
            return;
          }

          this.submitLoading = true;

          try {
            // 处理提交数据
            const submitData = {
              ...this.form,
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token')
            };

            let res;
              // 新增 - 批量创建分润设置
                // 单个创建
                res = await this.$axios.ShopBalanceSetSaveAll({
                  ...submitData
                });

                // 批量创建
               // res = await this.batchCreateBalanceSettings(submitData);

            if (res.code === 200) {
              this.$message.success(res.msg || '操作成功');
              this.$emit('success');
              this.handleClose();
            } else {
              this.$message.error(res.msg || '操作失败');
            }
          } catch (error) {
            console.error('操作失败:', error);
            this.$message.error('操作失败，请重试');
          } finally {
            this.submitLoading = false;
          }
        });
      },

      // 批量创建分润设置
      async batchCreateBalanceSettings(data) {
        const promises = data.balanceSettings.map(setting => {
          return this.$axios.ShopBalanceSetSave({
            shop_id: data.shop_id,
            balance_params_id: data.balance_params_id,
            status: data.status,
            remark: data.remark,
            proxy_sn: setting.proxy_sn,
            rate: setting.rate,
            company_id: data.company_id,
            access_token: data.access_token
          });
        });

        const results = await Promise.all(promises);
        // 检查所有请求是否成功
        const allSuccess = results.every(result => result.code === 200);

        if (allSuccess) {
          return { code: 200, msg: '批量创建成功' };
        } else {
          return { code: 500, msg: '部分分润设置创建失败' };
        }
      },

      // 关闭弹窗
      handleClose() {
        this.dialogVisible = false;
        this.$emit('update:visible', false);
        this.submitLoading = false;
        this.resetForm();
      },

      // 获取商户信息
      async fetchShopInfo(shopId) {
        try {
          const params = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            id: shopId
          };
          const res = await this.$axios.findShopOne(params);
          if (res.code === 200 && res.data) {
            this.selectedShopInfo = res.data;
          } else {
            this.$message.error('获取商户信息失败');
          }
        } catch (error) {
          console.error('获取商户详情失败:', error);
          this.$message.error('获取商户信息失败');
        }
      }
    }
  };
</script>

<style scoped>
  .balance-settings-container {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 16px;
    background: #f8f9fa;
  }

  .settings-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e4e7ed;
  }

  .header-title {
    font-weight: bold;
    color: #303133;
  }

  .header-tip {
    font-size: 12px;
    color: #909399;
  }

  .balance-setting-item {
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px dashed #e4e7ed;
  }

  .balance-setting-item:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }

  .balance-total {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e4e7ed;
  }

  .total-info {
    flex: 1;
  }

  .total-rate {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .total-label {
    font-weight: bold;
    color: #303133;
    margin-right: 8px;
  }

  .total-value {
    font-weight: bold;
    color: #409EFF;
    font-size: 16px;
  }

  .rate-tip {
    font-size: 12px;
    color: #f56c6c;
  }

  /* 商户信息展示样式 */
  .shop-info-display {
    margin-top: 8px;
  }

  .selected-shop-content {
    padding: 8px;
  }

  .selected-shop-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }

  .selected-shop-name {
    font-weight: 600;
    color: #303133;
    font-size: 14px;
  }

  .selected-shop-details {
    font-size: 12px;
    color: #606266;
  }

  .detail-item {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    line-height: 1.4;
  }

  .detail-item i {
    margin-right: 8px;
    color: #909399;
    width: 16px;
    text-align: center;
  }

  .detail-item:last-child {
    margin-bottom: 0;
  }

  /* 分润类型展示样式 */
  .balance-type-display {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .balance-type-desc {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #909399;
  }

  .balance-type-desc i {
    margin-right: 4px;
  }
</style>
